import { createFileRoute } from '@tanstack/react-router'

import { SpaceUsersPage } from '@/pages/space-members/SpaceUsers.page'

export const Route = createFileRoute('/_auth/$companyId/spaces/$spaceId/users')(
  {
    component: SpaceUsersPage,
    loader: () => ({ breadcrumbTitle: 'Users' }),
  },
)
